<template>
    <base-loader v-if="loading"/>

    <table v-else class="table is-striped is-fullwidth">
        <tbody>
            <tr v-for="space_team in space_teams" :key="space_team.id">
                <td>{{space_team.team.name}}</td>
                <td><role :role="space_team.role"/></td>

                <td v-if="space_permission('SPACE_TEAM_DELETE', space)">
                    <i @click="remove(space_team.team.id)" class="icon fas fa-times-circle"></i>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import Role from '../common/Role.vue';

export default {
    components: { Role },
    props: ['space_teams', 'loading', 'space'],
    methods: {
        remove(team_id) {
            this.$store.dispatch('space_teams/remove', {
                space_id: this.space.id,
                team_id,
            }).then(() => {
                this.$emit('removed');
            });
        },
    },
};
</script>
